export { lineClamp } from './lineClamp';
